/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
*/
'use strict';

/**
* This directive enables content block elements to be draggable and droppable.
* This directive should ONLY be attached to block elements and be placed within
* an element, that per the current standard, is the first child of a bulb-frame element.
*/
angular.module('bulbApp.contentEditorModule')

.directive('bulbDragNDrop', ['$compile', bulbDragNDrop]);

function bulbDragNDrop($compile) {

  return {
    require: ['?^mediumContentEditor', '^contentBlock', '^bulbFrame'],
    link: function(scope, elem, attr, ctrls, transclude) {

      var contentEditorCtrl = ctrls[0];
      if (!contentEditorCtrl) {
        return;
      }

      var contentBlockCtrl = ctrls[1];
      var blockType = contentBlockCtrl.contentBlock.blockType;

      var dropOn;  // element within the DOM where we want to place our dragged element bellow
      var draggedBlockContent; // the content of the dragged element. Stored so it can be passed between events.

      /*
      * Creates a meta element and then appends it to the element that this directive binds to.
      * This meta element prevents the viewport on touch devices from resizing, this is implemented
      * to disable touch gestures on draggable elements.
      */
      var metaTag = document.createElement('meta');
      metaTag.name = 'viewport';
      metaTag.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
      elem.append(metaTag);

      scope.$watch('contentBlockCtrl.selected', function contentBlockSelected(newValue, oldValue) {
        if (newValue !== oldValue) {
          // This means that the content-block has been selected
          elem.attr('draggable', 'true');
        } else {
          elem.attr('draggable', 'false');
        }
      });

      /*
      * Drag Events
      */
      var contentBlockElement = contentBlockCtrl.contentBlockElement[0];
      if (contentBlockElement) {
        elem.addClass('mobile-longpress-features-off');
        jQuery(contentBlockElement).on('dragstart', drag);
      }

      /*
      * Drop Events
      */
      var editor = contentEditorCtrl.editor.elements[0];
      if (editor) {
        jQuery(editor).on('drop', drop);
        jQuery(editor).on('dragover', allowDrop);
      }

      /*
      * Drag event, disguised as a function for reusability
      * Used to save the HTML of the dragged element and then
      * re-accessed from the drop event. (Cross-function data transfer)
      */
      function drag(evnt) {

        // Only allow an element to be dragged if it is selected
        if (contentEditorCtrl.selectedBlock !== null &&
          (contentEditorCtrl.selectedBlock.id === contentBlockElement.id)) {

          draggedBlockContent = contentBlockElement.outerHTML;

          if (evnt.originalEvent.dataTransfer) {
            evnt.originalEvent.dataTransfer.setDragImage(contentBlockElement, 0, 0);
          }
        } else {
          evnt.preventDefault();
        }
      }

      /*
      * Inserts a node after a reference node on the DOM. This allows for a media
      * block to be placed after another media block or after a paragraph element.
      */
      function insertAfter(elem, refElem) {

        var parent = refElem.parentNode;
        var next = refElem.nextSibling;
        if (next) {
          parent.insertBefore(elem, next);
        } else {
          parent.appendChild(elem);
        }
      }

      function getElementAncestor(element) {
        if (!element || element.parentElement === jQuery('.bulb-page-content')[0]) {
          return element;
        }
        return getElementAncestor(element.parentNode);
      }

      /*
      * Disables the default behavior of a drop on the screen
      * Within certain web broswers dropping elements around
      * on the screen has the potential to open them in a different
      * browser window.
      *
      * Additionally it provides checks to make sure that content-blocks
      * are only placed on valid elements.
      *
      * Additionally, it handles scrolling within mobile browsers. If the user
      * pulls the element to the top it will scroll up and if they pull it to the
      * bottom it will scroll down.
      *
      * Function must be called within the ondrop event of an elements
      * inorder for media blocks to be allowed to be dropped within them.
      */
      function allowDrop(evnt) {

        //fixed/standardized offset to allow for scrolling of the page
        var scrollOffset = 25;

        // Custom scrolling for mobile clients.
        if (evnt.clientY < scrollOffset) {

          window.scrollBy(0, -scrollOffset);
        } else if (evnt.clientY > jQuery(window).height() - scrollOffset) {

          window.scrollBy(0, scrollOffset);
        }
        // end custom scrolling

        evnt.preventDefault();
        dropOn = jQuery(evnt.target)[0];
      }

      /*
      * Disables the default behavior of a drop on the screen
      * Within certain web broswers dropping elements around
      * on the screen has the potential to open them in a different
      * browser window.
      */
      function drop(evnt) {

        evnt.preventDefault();
        var dropLocation = jQuery(dropOn).closest('content-block')[0];
        dropOn = jQuery(getElementAncestor(dropOn))[0];

        if (draggedBlockContent && dropOn) {

          // create a template element to store the @String content from above
          // set the innerHTML to be the same as @content above
          // this converts a string to a angular DOM element
          var toInsert = document.createElement('template');
          toInsert.innerHTML = draggedBlockContent;
          toInsert = toInsert.content.childNodes[0];
          toInsert = angular.element(toInsert);

          // check to make sure we are not placing the element after itself
          if (!(dropLocation) || (toInsert[0].id !== dropLocation.id)) {

            draggedBlockContent = '';
            jQuery('#' + toInsert[0].id).remove();

            var compiled = $compile(toInsert);
            insertAfter(toInsert[0], dropLocation || dropOn);
            compiled(scope);

            // Re-create the state of the image carousel
            if (blockType === 'IMAGE_CAROUSEL') {
              scope.$emit('command-carousel-draggable-drop', {draggable: false,
                selectedBlock: contentBlockCtrl.contentBlock});
            }

            contentEditorCtrl.insertBlockExtension.unselectBlock();
            contentEditorCtrl.updateToolbar();
            contentEditorCtrl.editor.trigger('editableInput', null, contentEditorCtrl.editor.elements[0]);

          }
        }
      }
    }
  };
}
